import { combineReducers } from 'redux';
import { INIT_TOOLBAR_REQUEST, INIT_TOOLBAR_SUCCESS, INIT_TOOLBAR_FAILURE } from './constants';

const fetching = (state = false, action) => {
    switch (action.type) {
        case INIT_TOOLBAR_REQUEST:
            return true;
        case INIT_TOOLBAR_SUCCESS:
        case INIT_TOOLBAR_FAILURE:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case INIT_TOOLBAR_FAILURE:
            return action.response.message;
        case INIT_TOOLBAR_SUCCESS:
        case INIT_TOOLBAR_REQUEST:
            return '';
        default:
            return state;
    }
};

const successInitToolbar = (state = false, action) => {
    switch (action.type) {
        case INIT_TOOLBAR_SUCCESS:
            return true;
        case INIT_TOOLBAR_REQUEST:
        case INIT_TOOLBAR_FAILURE:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    successInitToolbar,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/toolbar/reducer.js